import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetRoles = () => {
  const data = useQuery(["rolesList"], () =>
    axiosClient.get("/Roles/GetRolesList")
  );

  return data;
};
export default useGetRoles;
